import { EventTypeInputReg } from '../types/ViewModel/EventTypeInputReg';
import { EventTypeInput } from '../types/ViewModel/EventTypeInput';
import { DropdownItemReg } from '../types/ViewModel/DropdownItemReg';
import { DropdownGroupReg } from '../types/ViewModel/DropdownGroupReg';
import { RatingReg } from '../types/ViewModel/RatingReg';
import DropdownGroupRegFactory from './DropdownGroupRegFactory';
import RatingRegFactory from './RatingRegFactory';
import { InputDataTypeEnum } from '../enums/inputDataTypeEnum';
import { EventTypeInputRegBM } from '../types/BusinessModel/EventTypeInputRegBM';
import eventtypecommon from '../utils/event/eventtypecommon';
import { isNullOrUndefined } from 'src/utils/objectUtils';

export default () => {
    const { generateUuid } = eventtypecommon();
    const { newDropdownGroupReg, createDropdownGroupReg, createDropdownGroupRegBM } = DropdownGroupRegFactory();
    const { newRatingReg, createRatingReg, createRatingRegBM } = RatingRegFactory();

    const newEventTypeInputRegArray = (eventTypeInputRegList: EventTypeInputRegBM[]): EventTypeInputReg[] => {
        const eventTypeInputArray: EventTypeInputReg[] = [];
        eventTypeInputRegList.map((reg) => {
            eventTypeInputArray.push(newEventTypeInputReg(reg));
        });
        return eventTypeInputArray;
    };

    const newEventTypeInputReg = (eventTypeInputReg: EventTypeInputRegBM): EventTypeInputReg => {
        let eventTypeInputRegId: string;
        if (eventTypeInputReg.eventTypeInputRegId) {
            eventTypeInputRegId = eventTypeInputReg.eventTypeInputRegId;
        } else {
            eventTypeInputRegId = generateUuid();
        }

        let datetimeValueReg: Date | null = null;
        if (eventTypeInputReg.datetimeValueReg) {
            datetimeValueReg = new Date(eventTypeInputReg.datetimeValueReg);
        }

        return new EventTypeInputReg(
            eventTypeInputRegId,
            eventTypeInputReg.eventTypeInputId,
            eventTypeInputReg.inputDataTypeId,
            eventTypeInputReg.dropdownGroupReg ? newDropdownGroupReg(eventTypeInputReg.dropdownGroupReg) : null,
            eventTypeInputReg.ratingReg ? newRatingReg(eventTypeInputReg.ratingReg) : null,
            eventTypeInputReg.intValueReg,
            !isNullOrUndefined(eventTypeInputReg.intValueReg) ? eventTypeInputReg.intValueReg.toString() : null,
            eventTypeInputReg.decimalValueReg,
            !isNullOrUndefined(eventTypeInputReg.decimalValueReg) ? eventTypeInputReg.decimalValueReg.toString() : null,
            eventTypeInputReg.stringValueReg,
            datetimeValueReg,
            eventTypeInputReg.checkboxValueReg,
            true
        );
    };

    const createNewEventTypeInputRegFromCode = (
        eventTypeInputId: number,
        inputDataTypeId: InputDataTypeEnum,
        dropdownGroupReg: DropdownGroupReg | null,
        ratingReg: RatingReg | null,
        intValueReg: number | null,
        intValueRegStr: string | null,
        decimalValueReg: number | null,
        decimalValueRegStr: string | null,
        stringValueReg: string | null,
        datetimeValueReg: Date | null,
        datetimeValueRegDisplay: Date | null,
        checkboxValueReg: boolean | null,
        isValid: boolean
    ): EventTypeInputReg => {
        const eventTypeInputRegId = generateUuid();
        const newEventTypeInputReg = new EventTypeInputReg(
            eventTypeInputRegId,
            eventTypeInputId,
            inputDataTypeId,
            createDropdownGroupReg(dropdownGroupReg),
            createRatingReg(ratingReg),
            intValueReg,
            intValueRegStr,
            decimalValueReg,
            decimalValueRegStr,
            stringValueReg,
            datetimeValueReg,
            checkboxValueReg,
            isValid
        );
        newEventTypeInputReg.datetimeValueRegDisplay = datetimeValueRegDisplay;
        return newEventTypeInputReg;
    };

    const createNewEventTypeInputReg = (eventTypeInputReg: EventTypeInputReg): EventTypeInputReg => {
        const newEventTypeInputReg = new EventTypeInputReg(
            eventTypeInputReg.eventTypeInputRegId,
            eventTypeInputReg.eventTypeInputId,
            eventTypeInputReg.inputDataTypeId,
            createDropdownGroupReg(eventTypeInputReg.dropdownGroupReg),
            createRatingReg(eventTypeInputReg.ratingReg),
            eventTypeInputReg.intValueReg,
            eventTypeInputReg.intValueRegStr,
            eventTypeInputReg.decimalValueReg,
            eventTypeInputReg.decimalValueRegStr,
            eventTypeInputReg.stringValueReg,
            eventTypeInputReg.datetimeValueReg,
            eventTypeInputReg.checkboxValueReg,
            eventTypeInputReg.isEmpty
        );
        newEventTypeInputReg.datetimeValueRegDisplay = eventTypeInputReg.datetimeValueRegDisplay;
        newEventTypeInputReg.hasFocus = eventTypeInputReg.hasFocus;
        newEventTypeInputReg.hasBeenVisible = eventTypeInputReg.hasBeenVisible;
        return newEventTypeInputReg;
    };

    const createNewEventTypeInputRegArray = (eventTypeInputRegArray: EventTypeInputReg[] | null): EventTypeInputReg[] => {
        const eventTypeInputArray: EventTypeInputReg[] = [];
        if (eventTypeInputRegArray && eventTypeInputRegArray.length > 0) {
            eventTypeInputRegArray.map((reg) => {
                const item = createNewEventTypeInputReg(reg);
                if (item) {
                    eventTypeInputArray.push(item);
                }
            });
        }
        return eventTypeInputArray;
    };

    const createNewEventTypeInputRegForDate = (
        eventTypeInputId: number,
        inputDataTypeId: InputDataTypeEnum,
        dropdownGroupReg: DropdownGroupReg | null,
        ratingReg: RatingReg | null,
        intValueReg: number | null,
        intValueRegStr: string | null,
        decimalValueReg: number | null,
        decimalValueRegStr: string | null,
        stringValueReg: string | null,
        datetimeValueReg: Date | null,
        datetimeValueRegDisplay: Date | null,
        checkboxValueReg: boolean | null,
        isValid: boolean
    ): EventTypeInputReg => {
        const eventTypeInputRegId = generateUuid();
        const newEventTypeInputReg = new EventTypeInputReg(
            eventTypeInputRegId,
            eventTypeInputId,
            inputDataTypeId,
            createDropdownGroupReg(dropdownGroupReg),
            createRatingReg(ratingReg),
            intValueReg,
            intValueRegStr,
            decimalValueReg,
            decimalValueRegStr,
            stringValueReg,
            datetimeValueReg,
            checkboxValueReg,
            isValid
        );
        newEventTypeInputReg.datetimeValueRegDisplay = datetimeValueRegDisplay;
        newEventTypeInputReg.hasFocus = false;
        return newEventTypeInputReg;
    };

    const createDropdownItemRegfromSelection = (selectedIds: number[], eventTypeInput: EventTypeInput): DropdownItemReg[] => {
        let dropdownItemRegList: DropdownItemReg[] = [];
        if (eventTypeInput.inputDataTypeId === InputDataTypeEnum.Dropdown && eventTypeInput.dropdownGroup) {
            dropdownItemRegList = eventTypeInput.dropdownGroup.dropdownItemArray
                .filter((di) => {
                    return selectedIds.some((id) => {
                        return id === di.id;
                    });
                })
                .map((eti) => {
                    return new DropdownItemReg(generateUuid(), eti.dropdownItemId, eti.name);
                });
        }
        return dropdownItemRegList;
    };

    const createEventTypeInputRegBMList = (eventTypeInputRegList: EventTypeInputReg[] | null): any[] => {
        if (eventTypeInputRegList) {
            return eventTypeInputRegList.map((item) => {
                return {
                    eventTypeInputRegId: item.eventTypeInputRegId,
                    eventTypeInputId: item.eventTypeInputId,
                    inputDataTypeId: item.inputDataTypeId,
                    dropdownGroupReg: createDropdownGroupRegBM(item.dropdownGroupReg),
                    ratingReg: createRatingRegBM(item.ratingReg),
                    intValueReg: item.intValueReg,
                    decimalValueReg: item.decimalValueReg,
                    stringValueReg: item.stringValueReg,
                    checkboxValueReg: item.checkboxValueReg,
                    datetimeValueReg: item.datetimeValueReg,
                };
            });
        }
        return [];
    };

    return {
        newEventTypeInputRegArray,
        newEventTypeInputReg,
        createNewEventTypeInputRegFromCode,
        createNewEventTypeInputReg,
        createNewEventTypeInputRegArray,
        createNewEventTypeInputRegForDate,
        createDropdownItemRegfromSelection,
        createEventTypeInputRegBMList,
    };
};
